<template>
    <div class="container">
        <div class="head-guding">
        <div class="container-head">
            <span class="back" @click="back">
                <img src="../assets/img/back.png" alt="" style="margin-right:5px;width: 10px;height: 16px;">
                <span class="copy_txt_back">返回</span>
            </span>
            <span class="container-head-title">{{sonMsg.nameCn}}</span>
            <span v-clipboard:copy="copy_content"  v-clipboard:success="copy_success" v-clipboard:error="copy_error" class="copy">
                <span class="copy_txt_share">分享文章</span>
                <i class="iconfont icon-lianjie"></i>
            </span> 
        </div>
        <div class="container-head-time">{{sonMsg.alterDate}}</div>
        </div>
        <div class="container-box">
            <span v-html="sonMsg.content" @click="imgDialog($event)"></span>
            <div class="annexDown" v-if="sonMsg.annex">
                <div>附件下载：</div>
                <div v-for="(item,index) in annexArr" :key="index" style="margin-bottom:5px;">
                    <img src="../assets/img/annex.png" alt="">
                        <a @click="downloadItem(item,annexTitle[index])" class="download">{{annexArr.length == 1?"附件":"附件"+(index+1)}}：{{annexTitle[index]}}</a>
                </div>
            </div>
        </div>
        <div class="container-footer">
            <div v-if="(preShow || nextShow) && sonMsg.annex" style="height:1px;background:#eee;margin:0 20px 10px;"></div>
            <!-- 上一条、下一条 -->
            <div v-if="checkTime == true">
                <el-tooltip class="item" effect="dark" v-if="preShow" :content="preNameCn" placement="top-start">
                    <a @click="precontent" v-if="preShow" style="margin:auto 20px;cursor:pointer;float:left;">{{preNameCnSix}}</a>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" v-if="nextShow" :content="nextNameCn" placement="top-start">
                    <a @click="nextcontent" v-if="nextShow" style="margin:auto 20px;cursor:pointer;float:right;">{{nextNameCnSix}}</a>
                </el-tooltip>
            </div>
            <div style="clear:both;"></div>
        </div>
        <el-dialog title="图片预览" :visible.sync="showimage" :top="dialogTop>400?'5vh':'25vh'" :width="dialogWidth">
                <img :src="showimagesrc" style="width:100%;height:100%" alt="" >
        </el-dialog>
    </div>
</template>
<script>
import {
    // getHelpActicleByNumberCodeForPc,
    addHelpActicleBrowseNumForPc,
    // addHelpActicleUsefulReviewNumForPc,
    // addHelpActicleUnusefulReviewNumForPc

} from '@/api/api.js'
export default {
    name: 'detail',
    props:{
        sonMsg:{},
        preNext:{},
        listIdx:{}
    },
    data() {
        return {
            msg:'22222222222222222222',
            checkTime:true,
            showimage:false,
            showimagesrc:'',//图片显示路径
            preShow:true,
            nextShow:true,//上下条显示
            preNameCnSix:'',
            nextNameCnSix:'',//上下条截取名称
            preNameCn:'',
            nextNameCn:'',//上下条名称
            copy_content:window.location.origin+"/#/?id="+this.sonMsg.numberCode,//复制链接
            dialogWidth:"1500px",
            dialogHeight:" ",
            copy_img:require("../assets/img/link.png"),
            dialogTop:'',
            annexArr:[],
            annexTitle:[],//附件题目
        }
    },

    methods:{
        getCookie(){
            var strcookie = document.cookie;//获取cookie字符串
            var arrcookie = strcookie.split("; ");//分割
            //遍历匹配
            for ( var i = 0; i < arrcookie.length; i++) {
                var arr = arrcookie[i].split("=");
                if (arr[0] == ('checkTime'+this.sonMsg.numberCode)){
                    return arr[1];
                }
            }
            return true;
        },
        setcookie(){
            var time = new Date();
            time.setTime(time.getTime + 24 * 3600 * 1000); //过期时间为24小时.
            document.cookie = "checkTime"+this.sonMsg.numberCode+" = " + escape('false') + "; expires= " + time.toGMTString();
        },
        async addHelpActicleBrowseNumForPc(){
            await addHelpActicleBrowseNumForPc({
                numberCode:this.sonMsg.numberCode
            })
        },
        // async addHelpActicleUsefulReviewNumForPc(){
        //     await addHelpActicleUsefulReviewNumForPc({
        //         numberCode:this.sonMsg.numberCode
        //     })
        //     this.setcookie()
        //     this.checkTime = false
        // },
        // async addHelpActicleUnusefulReviewNumForPc(){
        //     await addHelpActicleUnusefulReviewNumForPc({
        //         numberCode:this.sonMsg.numberCode
        //     })
        //     this.setcookie()
        //     this.checkTime = false
        // },
        startPreNext(){
             // 判断点击列表listIdx，显示上一条下一条
            if(this.preNext.length != 1){
                if(this.listIdx == 0){
                    this.preShow = false
                    this.nextShow = true
                    this.nextNameCn = this.preNext[1].nameCn
                    this.nextNameCnSix = this.nextNameCn.length >9 ?'下一条:'+this.nextNameCn.slice(0,9)+'...' :'下一条:'+ this.nextNameCn

                }else if(this.listIdx == this.preNext.length-1){
                    this.preShow = true
                    this.nextShow = false
                    this.preNameCn = this.preNext[this.listIdx-1].nameCn
                    this.preNameCnSix = this.preNameCn.length >9 ?'上一条:'+this.preNameCn.slice(0,9)+'...' :'上一条:'+ this.preNameCn
                }else{
                    this.preShow = true
                    this.nextShow = true
                    this.getName(this.listIdx)
                    this.getNameSix()
                }
            }else{
                this.preShow = false
                this.nextShow = false
            }
        },
        precontent(){
            if(document.documentElement.scrollTop > 50){
                document.documentElement.scrollTop = 50
            }
            this.preNext.forEach((item,index) =>{
                if(item.numberCode == this.sonMsg.numberCode){
                    index -=1   
                    this.$emit('changeprop',index)
                    this.nextShow = true
                    if(index == 0){  //第一条不显示
                        this.preShow = false
                        this.nextNameCn = this.preNext[index+1].nameCn
                        this.nextNameCnSix = this.nextNameCn.length >9 ?'下一条:'+this.nextNameCn.slice(0,9)+'...' :'下一条:'+ this.nextNameCn
                    }else{
                        this.getName(index)
                        this.getNameSix()
                       
                    }
                    
                }
            })
        },
        nextcontent(){
            if(document.documentElement.scrollTop > 50){
                document.documentElement.scrollTop = 50
            }
            this.preNext.forEach((item,index) =>{
                if(item.numberCode == this.sonMsg.numberCode){//防止文章重名，numberCode代替nameCn
                    index +=1  
                    this.$emit('changeprop',index)
                    this.preShow = true
                    if(index == this.preNext.length-1){//最后一条不显示
                        this.nextShow = false
                        this.preNameCn = this.preNext[index-1].nameCn
                        this.preNameCnSix = this.preNameCn.length >9 ?'上一条:'+this.preNameCn.slice(0,9)+'...' :'上一条:'+ this.preNameCn
                    }else{
                        this.getName(index)
                        this.getNameSix()
                        
                    }  
                }
            })
            
        },
        getNameSix(){
            this.nextNameCnSix = this.nextNameCn.length>9?'下一条:'+this.nextNameCn.slice(0,9)+'...' :'下一条:'+ this.nextNameCn

            this.preNameCnSix = this.preNameCn.length>9?'上一条:'+this.preNameCn.slice(0,9)+'...' :'上一条:'+ this.preNameCn
        },
        getName(index){
            this.nextNameCn = this.preNext[index+1].nameCn
            this.preNameCn = this.preNext[index-1].nameCn
        },
        imgDialog(e){ //图片dialog
            if(e.target.tagName == 'IMG'){
                this.showimagesrc = e.target.currentSrc
                this.showimage = true
            }
            this.dialogWidth = e.target.naturalWidth>1500?"1500px": e.target.naturalWidth+ "px"
            this.dialogTop = e.target.naturalWidth


        },
        back(){
            this.$parent.getIndex(this.$parent.selIndex)
        },
        copy_success(){
            this.$message.success("链接已复制到剪切板");
        },
        copy_error(){
            this.$message.error("链接复制失败");
        },

        scrollToTop() {
            let $winScrollHeight = document.documentElement.scrollTop || document.body.scrollTop; // 浏览器滚动的距离

            if($winScrollHeight>180){
                this.$el.querySelectorAll(".head-guding")[0].classList.add("sticky");
                this.$el.querySelectorAll(".container-head-time")[0].style.marginBottom = "10px";
            }
            else{
                this.$el.querySelectorAll(".head-guding")[0].classList.remove("sticky");
                this.$el.querySelectorAll(".container-head-time")[0].style.marginBottom = "40px";
            }//文章题目固定

            let sl = document.body.scrollLeft || document.documentElement.scrollLeft;
            if(sl > document.documentElement.clientLeft){
                if(sl != 0){
                    let lr = -Math.max(document.body.scrollLeft,document.documentElement.scrollLeft);
                    this.$el.querySelectorAll('.head-guding')[0].style.left = lr + 230 + 'px';
                }
            }else{
                this.$el.querySelectorAll('.head-guding')[0].style.left = 'inherit';
            }
        },
        getFileTitle(){
            if(this.sonMsg.annex){
                this.annexTitle = [];
                let str = JSON.stringify(this.sonMsg.annex);
                str = str.replace(/"/g,'');
                this.annexArr = str.split(',');
                for(let i=0;i<this.annexArr.length;i++){
                    let first = this.annexArr[i].lastIndexOf('/');
                    this.annexTitle.push(this.annexArr[i].slice(first+1))
                }
            }
        },
        downloadItem(url, annexTitle) { //下载png,jpg,gif,doc等
            var x = new XMLHttpRequest();
            var resourceUrl = url;
            x.open("GET", resourceUrl, true);
            x.responseType = 'blob';
            x.onload = function () {
                // ie10+
                if (navigator.msSaveBlob) {
                    var name = resourceUrl.substr(resourceUrl.lastIndexOf("/") + 1);
                    return navigator.msSaveBlob(x.response, name);
                } else {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = annexTitle;
                    a.click();
                }
            }
            x.send();
        },


    },
    watch:{
        sonMsg:{
            handler(){
                this.$nextTick(()=>{
                     this.$el.querySelectorAll(".container-box span").forEach((item) =>{
                        item.style.fontSize="16px"
                        item.style.lineHeight="30px"
                    }),//文章详情字体大小和行间距
                    this.$el.querySelectorAll("img").forEach((item) =>{
                        item.style.cursor = "pointer"
                    }),//文章详情图片样式
                    this.copy_content= window.location.origin+"/#/?id="+this.sonMsg.numberCode
                })
                this.getFileTitle();//附件内容改变
                
            },
            deep:true,
        },
        //从搜索关键字改变上下条
        preNext:{
            handler(){
                    this.startPreNext()
            },
            deep:true
        },
        listIdx:{
            handler(){
                    this.startPreNext()
            },
            deep:true
        }
        
    },
   
    mounted(){
       
        window.addEventListener("scroll", this.scrollToTop);
        this.startPreNext() //一开始进入detail的上下条
        this.addHelpActicleBrowseNumForPc()
        this.checkTime = this.getCookie()
      
        this.$el.querySelectorAll(".container-box span").forEach((item) =>{
            item.style.fontSize="16px"
            item.style.lineHeight="30px"
        }),//文章详情字体大小和行间距

        this.$el.querySelectorAll("img").forEach((item) =>{
            item.style.cursor = "pointer"
        }) //文章详情图片样式

        this.getFileTitle();
    }
}
</script>
<style scoped lang="less">
.sticky{
    position:fixed;
    top: 46px;
    width: 1050px;
    background-color: #FAFAFB;
    padding-top: 26px;
    // height: auto !important;
}
.el-button--primary{
    height:30px;
    line-height:30px;
    padding: 0 20px;
}

.no-help{
    opacity: .45;
}
    .container{
        padding:0 20px 20px 0px;
        .container-head{
            display:flex;
            justify-content:space-between;
            margin-bottom: 10px;
            line-height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            .back{
                width: 48px;
                height: 30px;
                background-color: #eff0f4;
                padding: 0 10px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                .copy_txt_back{
                    font-size: 12px !important;
                    font-family: MicrosoftYaHei;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333;
                    margin-left:5px;
                }
            }
            .copy{
                width: 80px;
                height: 30px;
                background-image: linear-gradient(to right, #4561f0 , #c46fc2);
                padding: 0 6px 0 12px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                .copy_txt_share{
                    font-size: 12px !important;
                    font-family: MicrosoftYaHei;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #fff;                
                }
                i{
                    margin-left:10px;
                    font-size:20px;
                    color: #fff;
                }
            }
           
            .container-head-title{
                font-size: 20px !important;
                font-weight: 700;
                text-align: center;
                width: 80%;
                margin-left: 30px;
            }
            &:nth-child(1),&:nth-child(3){
                cursor:pointer;
            }

        }
        .container-head-time{
            font-size: 12px;
            color: #999;
            margin-bottom: 40px;
            text-align: center;
        }
        .container-box{
            padding: 0 20px;
            .annexDown{
                margin-top: 10px;
                &>div:first-child{
                    color:red;
                    font-size:14px;
                    margin-bottom:5px;
                }
            }
            .download{
                padding-left:8px;
                cursor:pointer;
                vertical-align: middle;
            }
        }
        .container-footer{
            margin-top: 14px;
        }

    }




</style>